__turbopack_context__.v({
  "itemLink": "TopBar-module-scss-module__haRa7W__itemLink",
});
